import BaseSettingHandler from './BaseSettingHandler';

/**
 *
 */
export class ShAutoWrapLink extends BaseSettingHandler {
  /**
   * read
   * @param options options
   */
  read(options: { $atom: JQuery; $activePanel: JQuery }) {
    const $target = options.$atom.find(this.setting.targetSelector as string);
    let value = '';
    const $link = $target.parent();
    if ($link?.length && $link[0].tagName === 'A') {
      const attrValue = $link.attr(this.setting.property);
      if (attrValue) {
        value = attrValue;
      }
      if (!value) {
        value = this.setting.default_value || '';
      }
    }
    setTimeout(() => {
      options.$activePanel
        .find(`[name="${this.setting.name}"]`)
        .attr('value', value)
        .val(value)
        .trigger('value-change');
    }, 0);
    return { value: value };
  }
  /**
   * write
   * @param options options
   */
  write(value: any, options: { $atom: JQuery }): { refreshType: string; style?: string | undefined } {
    const $target = options.$atom.find(this.setting.targetSelector as string);
    if (value != '') {
      let $link = $target.parent();
      if (!$link?.length || $link[0].tagName != 'A') {
        $target.wrap('<a target=""></a>');
        $link = $target.parent();
        $link.on('click', function (e) {
          e.preventDefault();
        });
      }
      $link.attr(this.setting.property, value);
    } else {
      $target.unwrap('a');
    }

    return {
      refreshType: 'css',
    };
  }
}
